module.exports = __webpack_public_path__ + "img/bslogo2.6ba43c36.png";